<template>
  <div>
    <textarea ref="textarea"
              :disabled="disabled"
              :id="id"
              :cols="cols"
              :rows="rows"
              :class="classes">{{ value }}</textarea>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default() {
        return '';
      }
    },
    id: {
      type: String,
      default() {
        return 'text-editor-'.concat(new Date().getTime());
      }
    },
    classes: {
      type: String,
      default() {
        return 'long-input';
      }
    },
    cols: {
      type: String,
      default() {
        return '30';
      }
    },
    rows: {
      type: String,
      default() {
        return '5';
      }
    },

    disabled: {
      type: Boolean,
      default() {
        return false;
      }
    },
  },

  data() {
    return {
      editor: null
    };
  },

  mounted() {
    this.initialize();
  },

  beforeDestroy() {
    this.destroy();
  },

  watch: {
    disabled() {
      this.editor.setReadOnly(this.disabled);
    }
  },

  methods: {
    initialize() {
      this.editor = CKEDITOR.replace(this.$el.firstElementChild, {
        uiColor: '#dddddd'
      });

      this.editor.on('change', () => {
        this.$emit('input', this.editor.getData());

        this.$emit('typing');
      });

      this.editor.on('focus', () => {
        this.$emit('focus', {});
      });

      this.$on('resetEditor', () => {
        this.editor.setData('');
      });

      this.$on('refreshEditor', () => {
        this.editor.setData(this.value);
      });
    },

    destroy() {
      this.editor.destroy();
    },
  }
};
</script>
